import config from ".";
const { API_BASE_PATH } = config;

// log events
export const LOG = `${API_BASE_PATH}log`;
export const NOTIFY_LOG = `${API_BASE_PATH}notify`;

//login and user registration
export const VALIDATIONS = `${API_BASE_PATH}validations`; // user validation before registration
export const CHANGE_PASSWORD = `${API_BASE_PATH}users/password`;
export const SIGNIN = `${API_BASE_PATH}auth`;

//Field Registration Map
export const REGISTRATIONS = `${API_BASE_PATH}fields/registrations/`; //get all registered fields
export const CLAIMS = `${API_BASE_PATH}claims`;

//WDP map
export const FARM_PRACTICES = `${API_BASE_PATH}fields/farm-practices`;
export const SHARE_FIELDS = `${API_BASE_PATH}fields/share`;
export const GET_USER_DETAILS = `${API_BASE_PATH}users/user-details`; //get user details to share field with

//APIs used in different modules
export const USERS = `${API_BASE_PATH}users`; //user registration and user water data
export const GRAPHS = `${API_BASE_PATH}users/graphdata`; //user registration and user water data
export const FIELDS = `${API_BASE_PATH}fields`; // Used for field operations in WDP and field Registration Map
export const GET_USER_FIELD_DETAILS = `${API_BASE_PATH}users/fields`; // get user fields details in WDP and field Registration Map
export const GET_GEO_JSON = `${API_BASE_PATH}geojson`; //used in dashboard, WDP and field Registration Map

// Well Report
export const REPORTS = `${API_BASE_PATH}reports`;
export const WELL = `${API_BASE_PATH}well`;
export const PUMP_RATES_SUMMARY = `${API_BASE_PATH}pump-rates-summary`;

// Staff as farmer login
export const SUPER_USER = `${API_BASE_PATH}superuser`;

// Seasonal Averages
export const AREA_AVERAGES = `${API_BASE_PATH}area-averages`;

//Field Transfer
export const GET_FILTERED_FIELDS_TO_TRANSFER = `${API_BASE_PATH}get-filtered-fields`;
export const GET_USER_BUSINESS_FARM = `${API_BASE_PATH}user-businesses-farms`;
export const TRANSFER_FIELDS = `${API_BASE_PATH}transfer-fields`;

export const PRECIP_DATA = `${API_BASE_PATH}get-precip-data`;
